<div class="container order-tracking-history">
  <div [appLoadingAnimation]="!isLoaded" class="app-loading">
    @if (orderDetails) {
      <div class="col-12 col-lg-10">
        <div class="row">
          <div class="col-12">
            <h3>{{ 'order-tracking-history.order-details' | translate }}</h3>
          </div>
        </div>
        <div class="row">
          <div class="col-12 col-lg-9">
            <h6 class="no-margin">{{ 'order-tracking-history.status-of-order' | translate }} {{ orderDetails.id }}</h6>
          </div>
          <div class="back-to-cart col-12 col-lg-3" (click)="backToOrders()"
            [attr.data-test]="(isHarmonizedPurchaseActivityEnabled$ | async) ? 'btn-backToPurchaseActivity' : 'btn-backToOrders'">
            <span class="icon-arrow-left"></span>
            @if (isHarmonizedPurchaseActivityEnabled$ | async) {
              {{ 'order-details.back-to-purchase-activity' | translate }}
            } @else {
              @if (!isApprover()) {
                {{ 'order-tracking-history.back-to-my-orders' | translate }}
              } @else {
                {{ 'order-tracking-history.back-to-hospital' | translate }}
              }
            }
          </div>
        </div>
        <div class="row">
          <div class="col-12 col-lg-1 order-icon">
            <span [ngClass]="orderIcon()"></span>
          </div>
          <div class="col-12 col-lg-8 collapsing-div">
            <div>
              <label>
                <strong>
                  {{
                  'order-tracking-history.status-bar-order-' +
                  getStatus(orderDetails.attributes.stateDisplayName) +
                  '-title' | translate: {number: orderDetails.id}
                  }}
                </strong>
              </label>
              @if (!isAuStore() && (!isJpStore() || showStatusForJpStore())) {
                <span>
                  {{
                  'order-tracking-history.status-bar-order-' +
                  getStatus(orderDetails.attributes.stateDisplayName) +
                  '-subtitle' | translate: {name: 'Approver Name'}
                  }}
                </span>
              }
              @if (showStatusBarEstimatedArrival()) {
                <span>
                  {{ 'order-tracking-history.status-bar-estimated-arrival' | translate }}
                </span>
              }
            </div>
          </div>
          @if (!isViewer() && !isOnlinePaymentFailed()) {
            <div class="col-12 col-lg-3 cancel-order-button"
                 [ngClass]="{'back-to-cart': orderDetails.attributes.stateDisplayName === 'new',
                                         'inactive': orderDetails.attributes.stateDisplayName !== 'new'}"
              (click)="cancelOrderModal()">
              <strong class="cancel-order-button--padding" [attr.data-test]="'button-cancelOrder'">
                {{ 'order-tracking-history.cancel-order' | translate }}
              </strong>
            </div>
          } @else if (!isViewer() && isOnlinePaymentFailed()) {
            <div class="col-12 col-lg-3 resume-payment-button"
              [ngClass]="{'inactive': !isPaymentRetryAvailable || isPaymentRetryLoading}"
              (click)="retryPayment()">
              <strong class="resume-order-button--padding">
                {{ 'order-tracking-history.retry-payment' | translate }}
              </strong>
            </div>
          }
        </div>
      </div>
      <div class="row justify-content-center">
        <div class="col-12 col-lg-10">
          <app-steps-bar
            [currentStatus]="orderDetails.attributes.stateDisplayName"
            [comment]="orderDetails.attributes.stateComment"
            [payment]="orderDetails.attributes.payments[0]">
          </app-steps-bar>
        </div>
      </div>
      <div class="row">
        <div class="col-12 order-item">
          <h3>{{ 'order-tracking-history.ordered-items' | translate }}</h3>
        </div>
      </div>
      <div class="row justify-content-between table-header-colors">
        <div class="col-12 col-lg-2">
          <div class="col-12 col-lg-10 padding-styling"
            [attr.data-test]="'label-order'">{{ 'order-tracking-history.order' | translate }}
          </div>
          <div class="col-12 col-lg-10" [attr.data-test]="'value-order'">
            <strong>{{ orderDetails.id }}</strong>
          </div>
        </div>
        <div class="col-12 col-lg-2">
          <div class="col-12 col-lg-10 padding-styling"
            [attr.data-test]="'label-orderedOn'">{{ 'order-tracking-history.ordered-on' | translate }}
          </div>
          <div class="col-12 col-lg-10 created-date" [attr.data-test]="'value-orderedOn'">
            <strong>{{ orderDetails.attributes.createdAt | formatDate }}</strong>
          </div>
        </div>
        <div class="col-12 col-lg-2 total-qty">
          <div class="col-12 padding-styling" [attr.data-test]="'label-totalQuantity'">
            {{ 'order-tracking-history.total-quantity' | translate }}
          </div>
          <div class="col-12" [attr.data-test]="'value-totalQuantity'">
            <strong>{{ totalQuantity }} {{ 'order-tracking-history.items' | translate }}</strong>
          </div>
        </div>
        @if (orderDetails.attributes.totals.discountTotal && isAuStore()) {
          <div class="col-12 col-lg-2 total-qty">
            <div class="col-12 no-padding text-right" [attr.data-test]="'label-promotionalCode'">
              {{ 'order-tracking-history.promotional-code' | translate }} ({{ getVoucherDiscount() }}%)
            </div>
            <div class="col-12 no-padding text-right" [attr.data-test]="'value-promotionalCode'">
              <strong>-{{ orderDetails.attributes.totals.discountTotal | currency: orderDetails.attributes.currencyIsoCode }}</strong>
            </div>
          </div>
        }
        <div class="col-12 col-lg-4">
          @if (!isAuStore()) {
            <div class="col-12 no-margin padding-styling total-sum"
              [attr.data-test]="'label-totalSum'">
              {{ 'order-tracking-history.total-sum' | translate }}
            </div>
          } @else {
            <div class="row no-margin no-padding">
              <div class="col-6 no-margin no-padding text-right" [attr.data-test]="'label-shippingCost'">
                {{ 'order-tracking-history.shipping-cost' | translate }}
              </div>
              <div class="col-6 no-margin no-padding total-sum" [attr.data-test]="'label-orderTotal'">
                {{ 'order-tracking-history.total-sum' | translate }}
              </div>
            </div>
          }
          @if (orderDetails.attributes.totals.subtotal !== orderDetails.attributes.totals.grandTotal &&
            !isAuStore()) {
            <div class="row no-margin no-padding">
              <div class="col-6 no-padding text-left" [attr.data-test]="'label-subtotal'">
                {{ 'order-tracking-history.subtotal' | translate }}
              </div>
              <div class="col-6 no-padding text-right" [attr.data-test]="'value-subtotal'">
                {{ orderDetails.attributes.totals.subtotal | currency: orderDetails.attributes.currencyIsoCode }}
              </div>
            </div>
          }
          @if (!isAuStore() && taxUtils.isExcludeTaxActive()) {
            <div class="row no-margin no-padding">
              <div class="col-8 no-padding text-left" [attr.data-test]="'label-taxPrice'">
                {{ 'order-review.gst-price' | translate }}
              </div>
              <div class="col-4 no-padding text-right align-sum" [attr.data-test]="'desc-taxPrice'">
                {{ orderDetails.attributes.totals.taxTotal | currency: orderDetails.attributes.currencyIsoCode }}
              </div>
            </div>
          }
          @for (discount of getDiscounts(); track discount.voucherCode) {
            @if (orderDetails.attributes.totals.discountTotal && !isAuStore()) {
              <div class="row no-margin no-padding">
                <div class="col-8 no-padding text-left" [attr.data-test]="'label-promotionalCode'">
                  {{ 'order-tracking-history.discount'| translate }} {{ discount.displayName }} - {{ discount.voucherCode }}
                </div>
                <div class="col-4 no-padding text-right align-sum" [attr.data-test]="'value-promotionalCode'">
                  - {{ discount.sumAmount | currency: orderDetails.attributes.currencyIsoCode }}
                </div>
              </div>
            }
          }
          <div class="promotional-code"></div>
          <div class="row no-margin no-padding">
            @if (!isAuStore()) {
              <div class="col-6 no-padding text-left"
                [attr.data-test]="'label-orderTotal'">
                <strong>
                  {{ (taxUtils.isExcludeTaxActive() ?
                  'order-tracking-history.order-total-incl-taxes' :
                  'order-tracking-history.order-total')
                  | translate }}
                </strong>
              </div>
            } @else {
              <div class="col-6 no-padding text-right" [attr.data-test]="'value-shippingCost'">
                <strong>
                  {{
                  (taxUtils.isExcludeTaxActive() ?
                  orderDetails.attributes.shipments[0].defaultNetPrice :
                  orderDetails.attributes.shipments[0].defaultGrossPrice)
                  | currency: orderDetails.attributes.currencyIsoCode
                  }}
                </strong>
              </div>
            }
            <div class="col-6 no-padding text-right" [attr.data-test]="'value-orderTotal'">
              <strong>
                {{ orderDetails.attributes.totals.grandTotal | currency: orderDetails.attributes.currencyIsoCode }}
              </strong>
            </div>
          </div>
        </div>
      </div>
      <br>
        <div class="row">
          <div class="col-12 col-lg-8 items-border">
            @for (item of orderDetails.attributes.items; track item) {
              <div class="item-border">
                <div class="row item" [attr.data-test]="'order-item-' + item.name">
                  <div class="col-12 col-lg-2">
                    <img src="{{ ImageUtils.addPreset(item.metadata.image, ImagePreset.Default) }}" alt="n/a">
                  </div>
                  <div class="col-12" [ngClass]="isAuStore() || isInStore() ? 'col-lg-10' : 'col-lg-8'">
                    <div class="row">
                      <div class="col-12">
                        <a [routerLink]="['/product/', `A_${item.sku}`]">
                          <h6 class="item--name">{{ item.name }}</h6></a>
                        </div>
                        @if (!isAuStore() && !isInStore()) {
                          <div class="col-12">
                            <div>
                              <h5 class="item--price">
                                {{ item.unitPrice | currency: orderDetails.attributes.currencyIsoCode }}
                              </h5>
                            </div>
                          </div>
                        }
                        @if (item.systemDetails) {
                          <div class="col-12 padding-styling">
                            <div>
                              <span class="item-system-details-span-styling">
                                {{ 'orders-page.selected-system' | translate }}
                              </span>
                              <span class="item-system-details-styling">
                                @if (item.systemDetails) {
                                  <span class="item-system-details-span-styling">
                                    {{ item.systemDetails | selectedSystem }}
                                  </span>
                                }
                              </span>
                            </div>
                            <div>
                              <span class="item-system-details-span-styling">
                                {{ 'orders-page.company' | translate }}
                              </span>
                              <span class="item-system-details-styling">
                                @if (item.systemDetails) {
                                  <span class="item-system-details-span-styling">
                                    {{ item.systemDetails | companyDetails }}
                                  </span>
                                }
                              </span>
                            </div>
                          </div>
                        }
                        @if (!isAuStore() && !isInStore()) {
                          <div class="col-12">
                            @if (item.deliveryAvailability) {
                              <span class="currently-in-stock">
                                {{ item.deliveryAvailability }}
                              </span>
                            }
                          </div>
                        }
                        @if (!isAuStore() && !isInStore()) {
                          <div class="col-12">
                            @if (item.deliveryTime) {
                              <span class="estimated-arrival-time">
                                {{ 'shop-cart.estimatedArrivalLabel' | translate }}{{ item.deliveryTime }}
                              </span>
                            }
                          </div>
                        }
                        @if (isAuStore()) {
                          <div class="col-12 order-info">
                            <div class="row">
                              <label class="col-12 sku">
                                {{ item.sku }}
                              </label>
                              <div class="col-6">
                                <div class="row">
                                  <label class="col-6">{{ 'order-approve.quantity' | translate }}:</label>
                                  <label class="col-6 text-right"
                                  [attr.data-test]="'label-itemQuantity'">{{ item.quantity }}</label>
                                </div>
                                <div class="row">
                                  <label class="col-6">{{ 'order-tracking-history.item-price' | translate }}:</label>
                                  <label class="col-6 text-right"
                                    [attr.data-test]="'label-itemPrice'">
                                    {{ item.sumPrice | currency: orderDetails.attributes.currencyIsoCode }}
                                  </label>
                                </div>
                              </div>
                              <div class="col-6">
                                <div class="row">
                                  <label class="col-6">{{ 'order-approve.tracking-number' | translate }}:</label>
                                  <label class="col-6 text-right" [attr.data-test]="'label-trackingNumber'">
                                    {{ orderDetails.attributes.trackingNumber ?? ('order-approve.no-tracking-number' | translate) }}
                                  </label>
                                </div>
                              </div>
                            </div>
                          </div>
                        }
                        @if (isInStore()) {
                          <div class="col-12">
                            <div class="row">
                              <h5 class="col-8 item--price">
                                {{ item.unitPrice | currency: orderDetails.attributes.currencyIsoCode }}
                              </h5>
                              <div class="col-4">
                                {{ item.quantity }}
                              </div>
                            </div>
                            <div class="row">
                              <div class="col-6">
                                @if (item.deliveryAvailability) {
                                  <span class="currently-in-stock">
                                    {{ item.deliveryAvailability }}
                                  </span>
                                }
                              </div>
                            </div>
                            <div class="row">
                              <div class="col-8">
                                @if (item.deliveryTime) {
                                  <span class="estimated-arrival-time">
                                    {{ 'shop-cart.estimatedArrivalLabel' | translate }}{{ item.deliveryTime }}
                                  </span>
                                }
                              </div>
                              <div class="col-4">
                                <span class="tracking-number">
                                  <span>
                                    {{ 'order-approve.tracking-number' | translate }}:
                                  </span>
                                  @if (orderDetails.attributes.trackingNumber) {
                                    <a href="{{ ('order-tracking-history.tracking-link' | translate) + orderDetails.attributes.trackingNumber }}"
                                      target="_blank" rel="noopener" [attr.data-test]="'link-trackingNumber'">
                                      {{ orderDetails.attributes.trackingNumber }}
                                    </a>
                                  } @else {
                                    <span>
                                      {{ 'order-approve.no-tracking-number' | translate }}
                                    </span>
                                  }
                                </span>
                              </div>
                            </div>
                          </div>
                        }
                      </div>
                    </div>
                    @if (!isAuStore() && !isInStore()) {
                      <div class="col-12 col-lg-2">
                        <br/>
                        <div>{{ item.quantity }}</div>
                      </div>
                    }
                  </div>
                </div>
              }
            </div>
            <div class="col-12 col-lg-4 address">
              <strong
                [attr.data-test]="'label-deliveryAddress'">{{ 'order-tracking-history.delivery-address' | translate }}
              </strong>
              <div [attr.data-test]="'desc-deliveryAddress'">
                <div [attr.data-test]="'desc-deliveryAddressName'">
                  @if (orderDetails.attributes.shippingAddress.firstName !== 'empty') {
                    <span [attr.data-test]="'desc-deliveryAddressFirstName'">
                      {{ orderDetails.attributes.shippingAddress.firstName }}
                    </span>
                  }
                  @if (orderDetails.attributes.shippingAddress.lastName !== 'empty') {
                    <span [attr.data-test]="'desc-deliveryAddressLastName'">
                      {{ orderDetails.attributes.shippingAddress.lastName }}
                    </span>
                  }
                </div>
                <div
                  [attr.data-test]="'desc-deliveryAddressAddress1'">{{ orderDetails.attributes.shippingAddress.address1 }}
                </div>
                @if (orderDetails.attributes.shippingAddress.address3 !== 'empty') {
                  <div [attr.data-test]="'desc-deliveryAddressAddress3'">
                    {{ orderDetails.attributes.shippingAddress.address3 }}
                  </div>
                }
                <div class="address--inline">
                  @if (orderDetails.attributes.shippingAddress.zipCode !== 'empty') {
                    <div [attr.data-test]="'desc-deliveryAddressZipCode'">
                      {{ orderDetails.attributes.shippingAddress.zipCode }}&nbsp;
                    </div>
                  }
                  @if (orderDetails.attributes.shippingAddress.city !== 'empty') {
                    <div [attr.data-test]="'desc-deliveryAddressCity'">
                      {{ orderDetails.attributes.shippingAddress.city }}
                    </div>
                  }
                  @if (orderDetails.attributes.shippingAddress.address2 !== 'empty') {
                    <div [attr.data-test]="'desc-deliveryAddressAddress2'">
                      , {{ orderDetails.attributes.shippingAddress.address2 }}
                    </div>
                  }
                </div>
                @if (orderDetails.attributes.shippingAddress.country !== 'empty') {
                  <div [attr.data-test]="'desc-deliveryAddressCountry'">
                    {{ orderDetails.attributes.shippingAddress.country }}
                  </div>
                }
              </div>
              @if (orderDetails.attributes.taxNumber) {
                <div class="cart-tax-number">
                  <ng-container>
                    <strong>{{ 'order-approve.billing-tax-number' | translate }}</strong>
                    <div>
                      <span>{{ orderDetails.attributes.taxNumber }}</span>
                    </div>
                  </ng-container>
                </div>
              }
              <div class="cart-system-details">
                @if (orderDetails.attributes.systemDetails && !isAuStore()) {
                  <strong
                    [attr.data-test]="'label-systemDetails'">{{ 'orders-page.system-details' | translate }}
                  </strong>
                  <div [attr.data-test]="'desc-systemDetails'" class="padding-styling">
                    <div>
                      <span [attr.data-test]="'label-systemDetailsSelectedSystem'">
                        {{ 'orders-page.selected-system' | translate }}
                      </span>
                      <div class="cart-system-details--line">
                        <span [attr.data-test]="'desc-systemDetailsSelectedSystem'">
                          {{ orderDetails.attributes.systemDetails | selectedSystem }}
                        </span>
                      </div>
                    </div>
                    <div>
                      <span [attr.data-test]="'label-systemDetailsCompany'">
                        {{ 'orders-page.company' | translate }}
                      </span>
                      <div class="cart-system-details--line">
                        <span [attr.data-test]="'desc-systemDetailsCompany'">
                          {{ orderDetails.attributes.systemDetails | companyDetails }}
                        </span>
                      </div>
                    </div>
                  </div>
                }
                @if (isAuStore()) {
                  <strong
                    [attr.data-test]="'label-shippingMethod'">{{ 'order-tracking-history.shipping-method' | translate }}
                  </strong>
                  <div class="padding-styling">
                    <div>
                      <span [attr.data-test]="'desc-shippingMethod'">
                        {{ orderDetails.attributes.shipments[0].shipmentMethodName }}
                      </span>
                    </div>
                  </div>
                }
              </div>
              @if (isInStore()) {
                <strong>{{ 'orders-page.payment-method' | translate }}</strong>
                <div class="padding-styling">
                  {{ OrdersUtils.getPaymentTranslationKey(orderDetails?.attributes?.payments?.[0]?.paymentProvider) | translate }}
                </div>
              }
            </div>
          </div>
        }
      </div>
    </div>
    <app-modal
      [open]="showModalCancelOrder"
      title="{{ 'order-tracking-history.cancel-order-modal-title' | translate:{number: orderId} }}"
      (crossClick)="restartShowModal()">
      <ng-container ngProjectAs="[slot][body]">
        @if (isOrderCanceling) {
          <div class="loader__overlay">
            <div class="loader__content">
              <div class="loading-animation"></div>
            </div>
          </div>
        }
        <h5 class="cancel-order-modal-title">
          {{ 'order-tracking-history.cancel-order-modal-content' | translate:{number: orderId} }}
        </h5>
      </ng-container>
      <ng-container ngProjectAs="[slot][footer]">
        <button type="button" (click)="restartShowModal()"
          class="button button"
          data-dismiss="modal-dialog"
          [attr.data-test]="'button-keepOrderModal'">
          {{ 'order-tracking-history.keep-order'  | translate }}
        </button>
        <button type="button" (click)="cancelOrder(orderId)"
          class="button button--primary"
          data-dismiss="modal-dialog"
          [attr.data-test]="'button-cancelOrderModal'">
          {{ 'order-tracking-history.cancel-order' | translate }}
        </button>
      </ng-container>
    </app-modal>
